import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FiZoomIn } from 'react-icons/fi';

import { cls } from '@mssgme/helpers';
import { LoadingIndicator } from '@mssgme/ui';
import { MediaSizes, useUploads } from '../../hooks';

import styles from './ServiceContent.scss';

export const ServicePhoto = React.forwardRef(function ServicePhoto(
    { photoUrl, title, index, style, onLoad, onClick, ...rest },
    ref
) {
    const { getMediaSizeUrl } = useUploads();
    const handleClick = useCallback(() => void onClick(index), [index, onClick]);

    return (
        <div ref={ref} {...cls(styles.slide, rest)}>
            <div className={styles.slideImage}>
                <img
                    {...{ 'data-src': getMediaSizeUrl(photoUrl, MediaSizes.Large) }}
                    className="swiper-lazy"
                    alt={title}
                    onLoad={onLoad}
                    onClick={handleClick}
                />
                <div className={styles.zoomIcon} style={style.common}>
                    <FiZoomIn size={14} />
                </div>
                <div className={styles.imagePreloader} style={style.background}>
                    <div>
                        <LoadingIndicator />
                    </div>
                </div>
            </div>
        </div>
    );
});

ServicePhoto.propTypes = {
    photoUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
    onLoad: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
};
